import { AstraBadge, AstraTooltip, DATE_TEMPLATES, format, getToday } from '~/astra'
import { PractitionerWaitingListCallout } from '~/components'
import { useOpenDialog } from '~/components/DialogRouter/useDialogRouter'
import { useCurrentWaitingListByPractitioner } from '~/hooks/useCurrentWaitingListByPractitioner'
import { Practitioner } from '~/storm'

import { InformationRow } from './InformationRow'
import { WaitingListAction } from './WaitingListAction'

type Props = {
    practitioner: Practitioner
}

export const CurrentWaitingList = ({ practitioner }: Props) => {
    const openPractitionerPopover = useOpenDialog('practitioner')
    const { isError, isLoading, isWaitingListEmpty, unScheduledSurgeriesByPractitionerCount, clearedSurgeriesByPractitionerCount } =
        useCurrentWaitingListByPractitioner(practitioner)

    const badgeText = isWaitingListEmpty ? '-' : `${unScheduledSurgeriesByPractitionerCount} (${clearedSurgeriesByPractitionerCount})`

    if (isError) {
        return <PractitionerWaitingListCallout type="error" />
    }

    return (
        <InformationRow isLoading={isLoading}>
            <WaitingListAction
                onClick={() => openPractitionerPopover({ practitioner })}
                title={'I dag'}
                subtitle={format(getToday(), DATE_TEMPLATES.norwegianDate)}
            />
            <AstraTooltip tooltipContent={`${unScheduledSurgeriesByPractitionerCount} pasienter (${clearedSurgeriesByPractitionerCount} klarerte)`}>
                <AstraBadge text={badgeText} />
            </AstraTooltip>
        </InformationRow>
    )
}
